import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const LanguageManagement = () => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    setLoading(true);
    setError("");
    try {
      const token = getAccessToken();
      const response = await Axios.get(
        Constant.apiBasePath + "language/get-all",
        { headers: { token } }
      );
      if (Array.isArray(response.data)) {
        setLanguages(response.data);
      } else if (response.data.status === Constant.statusSuccess) {
        setLanguages(response.data.data || []);
      } else {
        setError(response.data.message || "Failed to fetch languages");
      }
    } catch (err) {
      setError("Error fetching languages");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this language?"))
      return;
    setLoading(true);
    setError("");
    try {
      const token = getAccessToken();
      const response = await Axios.delete(
        Constant.apiBasePath + `language/delete/${id}`,
        { headers: { token } }
      );
      if (response.status === 200) {
        setLanguages(languages.filter((lang) => lang._id !== id));
      } else {
        setError(
          response.data && response.data.message
            ? response.data.message
            : "Failed to delete language"
        );
      }
    } catch (err) {
      setError("Error deleting language");
    }
    setLoading(false);
  };

  return (
    <div className="content-page contest-submissions-page contest-management-page language-management-page event-consistent-page">
      <div className="content page-content-spaced">
        <div className="event-management-header">
          <div className="header-content">
            <div className="header-title">
              <h4 className="page-title-heading">Language Management</h4>
              <p className="header-subtitle">
                Manage application language names and labels.
              </p>
            </div>
            <div className="header-actions">
              <Link
                to="/add-language"
                className="btn btn-primary btn-add-event contest-add-match"
              >
                + Add New
              </Link>
            </div>
          </div>
        </div>

        <div className="event-management-body">
          <div className="card contest-like-card">
            <div className="card-body">
              <div className="language-management-toolbar">
                <p id="gen-message" className="message-feedback">
                  {loading ? "Loading..." : error}
                </p>
              </div>

              <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                <table className="table event-table contest-submissions-table contest-like-table language-management-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Label</th>
                      <th>ObjectId</th>
                      <th className="actions-col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {languages.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="table-loading-cell">
                          No languages found.
                        </td>
                      </tr>
                    ) : (
                      languages.map((lang) => (
                        <tr key={lang._id}>
                          <td>{lang.name}</td>
                          <td>{lang.label}</td>
                          <td>{lang._id}</td>
                          <td className="actions-col language-actions-col">
                            <div className="language-actions-wrap">
                              <Link
                                to={`/edit-language/${lang._id}`}
                                className="contest-icon-btn"
                                title="Edit language"
                                aria-label="Edit language"
                              >
                                <FontAwesomeIcon icon={faEdit} style={{ fontSize: "13px" }} />
                              </Link>
                              <button
                                type="button"
                                className="contest-icon-btn danger"
                                onClick={() => handleDelete(lang._id)}
                                title="Delete language"
                                aria-label="Delete language"
                              >
                                <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "13px" }} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default LanguageManagement;
